export const OLD_PASSWORD = "Contraseña actual";
export const NEW_PASSWORD = "Nueva contraseña";
export const CONFIRM_NEW_PASSWORD = "Confirma tu nueva contraseña";

export const ALERT_TEXT = "A medida que avances en el proceso te pediremos información nueva. Mantén tu perfil actualizado";